
export async function setLog(context, param ) {
    try{
        context.commit('setLog',param);
    }
    catch(e){
        console.log(e);
    }
}

